import {FeatureAppLoader} from '@feature-hub/react';
import {
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import React from 'react';
import * as zoid from 'zoid/dist/zoid.frameworks';
import { DealerData, VehicleData } from '../../../../types';
import { LayerCloseHandle } from '../../../../types/layers';
import {
  FeatureServicesContext,
  useFeatureServices,
} from '../../../../use-feature-services';

interface EstimatesModalInterface {
  close: LayerCloseHandle;
  dealer?: DealerData;
  vehicle?: VehicleData;
}

declare global {
  interface Window {
    build_price?: any;
  }
}

const EstimatesModal = (props: EstimatesModalInterface) => {
  zoid.destroy();
  const featureServiceContext = useFeatureServices();
  const {'featureapp-service': featureAppService} = featureServiceContext;
  const financeUiDefinition = (featureAppService?.featureAppConfigurations as any)
    .financeUi;

  return (
    <ThemeProvider theme="main">
      <FeatureServicesContext.Provider value={featureServiceContext}>
        {featureServiceContext['finance-provider-service'] ? (
          <FeatureAppLoader
            {...financeUiDefinition}
            beforeCreate={(env) => {
              const contentService = env.featureServices['fa-content-service'] as FaContentServiceV1;
              if (contentService) {
                contentService.content = {
                  vehicle: props.vehicle
                };
              }
            }}
            featureAppId="finance-integration-ui-fa"
            done={() => {
              props.close();
            }}
          />
        ) : null}
      </FeatureServicesContext.Provider>
    </ThemeProvider>
  );
};

export default EstimatesModal;
